import { useTranslation } from 'react-i18next';
import NewWindowIcon from '@/public/icons/approval/new-window.svg';
import { formatApprovalDate } from '@/utils/approval/formatApprovalDate';
import RelatedItemRow from './RelatedItemRow';
import { NewWindowIconButton, ResultRowChrome } from './styles';
import type { RelatedApprovalItem } from './types';

type ResultItemProps = {
  item: RelatedApprovalItem;
  onSelect: (item: RelatedApprovalItem) => void;
  onOpenInNewWindow: (docId: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
};

// 새창 버튼은 row 동작(추가)과 분리 — 클릭은 stopPropagation, 키보드는 row 가 Enter 를
// 가로채므로 버튼에서 preventDefault+stopPropagation 후 직접 오픈(중복 방지).
const ResultItem = ({
  item,
  onSelect,
  onOpenInNewWindow,
  onKeyDown,
}: ResultItemProps) => {
  const { t } = useTranslation();
  return (
    <RelatedItemRow
      rootComponent={ResultRowChrome}
      dataResultItem
      role="button"
      tabIndex={0}
      title={item.subject}
      titleTone="plain"
      status={item.status}
      author={item.author.name}
      date={formatApprovalDate(item.authoredAt) ?? t('날짜 없음')}
      onClick={() => onSelect(item)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(item);
          return;
        }
        onKeyDown?.(e);
      }}
      trailing={
        <NewWindowIconButton
          type="button"
          aria-label={t('새창에서 열기')}
          onClick={(e) => {
            e.stopPropagation();
            onOpenInNewWindow(item.docId);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              onOpenInNewWindow(item.docId);
            }
          }}
        >
          <NewWindowIcon width={14} height={14} />
        </NewWindowIconButton>
      }
    />
  );
};

export default ResultItem;
